const User = (api: any) => ({
  login: (username: string, password: string) =>
    api.login(username, password),
  logout: () => api.logout(),
  updateUserDetails: (userId: number, userDetails: any) =>
    api.put(`/api/v1/user/${userId}`, {}, userDetails),
  createCustomer: (customerInfo: any) =>
    api.post('/api/v1/user/register', {}, customerInfo),
  searchCustomer: ({
    searchTerm,
    userId,
    name,
    email,
    mobile,
    countryCode,
    pageIndex,
    pageSize,
  }: {
    searchTerm?: string;
    userId?: number;
    name?: string;
    email?: string;
    mobile?: string;
    countryCode?: string;
    pageIndex?: number;
    pageSize?: number;
  }) => {
    const searchData = {
      searchTerm,
      userId,
      name,
      email,
      mobile,
      countryCode,
      pageIndex: pageIndex || 0,
      pageSize: pageSize || 10,
    }
    return api.post('/api/v1/user/customer/search', {}, searchData);
  },
});

export default User;
